import { isNotEmptyString } from "@pineapplelab/util";
import { Core } from "../../core/core";
/**
 * The value must have must have a maximum of {min} characters.
*/
export function MaxLength(max, options) {
    if (options === void 0) { options = {}; }
    return function (target, propertyKey) {
        var message = "The field: '" + (options.label ? options.label : propertyKey) + "' must have a maximum of " + max + " character" + (max > 1 ? 's' : '') + ".";
        Core.setFieldValidator(target, propertyKey, {
            name: 'MaxLength',
            isValid: function (o, f) { return isNotEmptyString(o[f]) && o[f].length <= max; },
            message: options.message ? options.message : message
        });
    };
}
